import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { WbUserDTO, WbUserPostDTO } from '../models/wb-user-dto';
import { environment } from '../../environments/environment';
import { DataTablesResponse } from '../models/datatables';

@Injectable({ providedIn: 'root' })
export class UserService {
  private pathAPI = environment.urlAPI;
  private controller = 'WbUser/';
  public userData = new BehaviorSubject<WbUserDTO>(null);

  constructor(private http: HttpClient) { }

  public initializeUserData() {
    this.getUserInfo().subscribe(resp => {
      this.setUserData(resp);
    });
  }

  public getUserInfo(): Observable<WbUserDTO> {
    return this.http.get<WbUserDTO>(this.pathAPI + this.controller + 'GetLoggedUserInfo');
  }

  setUserData(user: WbUserDTO) {
    this.userData.next(user);
  }

  getUserData(): Observable<WbUserDTO> {
    if (this.userData.value != null) {
      return this.userData.asObservable();
    } else {
      return this.getUserInfo().pipe(
        map((userData) => {
          this.userData.next(userData);
          return userData;
        }),
        catchError((err) => {
          return this.userData.asObservable();
        })
      );
    }
  }

  public get(id: string): Observable<WbUserDTO> {
    return this.http.get<WbUserDTO>(this.pathAPI + this.controller + id);
  }

  public insertAdmin(data: WbUserPostDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'InsertAdmin', data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  }
}
